import {generateClient} from "aws-amplify/api";
import {billingApiConfig} from "./config";

export const billingClient = generateClient({
    endpoint: billingApiConfig.endpoint,
    region: billingApiConfig.region,
    authMode: 'userPool'
});
